import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { theme } from '../theme/theme';

/**
 * 
 * Props:
 * - children: button text or content
 * - primaryColor: color on hover
 * - secondaryColor: default background color
 * - textColor: default text color (white by default)
 * - onClick: click handler
 * - style: additional inline styles
 */
const CustomBtn = ({
  children,
  primaryColor = theme.colors.primary,      // default hover color
  secondaryColor = theme.colors.secondary,    // default background color
  textColor = theme.colors.background,              // default text color
  onClick,
  style = {},
  ...rest
}) => {
  const [hover, setHover] = useState(false);

  const buttonStyle = {
    backgroundColor: hover ? primaryColor : secondaryColor,
    borderColor: hover ? primaryColor : secondaryColor,
    color: textColor,
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    ...style, // merge any additional styles
  };

  return (
    <Button
      {...rest}
      onClick={onClick}
      style={buttonStyle}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {children}
    </Button>
  );
};

export default CustomBtn;
